import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { mediaUrl } from "../lib/api";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands").then((r) => setBrands(r.data)).catch(() => {}); }, []);
  return (
    <div className="luxy-container py-12 sm:py-16">
      <div className="text-center mb-14">
        <p className="eyebrow mb-3">The Maisons</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-pitch tracking-tight">Shop by Brand</h1>
        <p className="text-charcoal/70 mt-4 max-w-xl mx-auto">Pre-owned pieces from the world's most enduring luxury houses, each individually sourced and inspected.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {brands.map((b) => (
          <Link key={b.id} to={`/shop?brand=${encodeURIComponent(b.name)}`}
            data-testid={`brand-card-${b.slug}`}
            className="group border border-linen bg-white p-8 hover:border-pitch transition-colors">
            <h2 className="font-serif text-3xl text-pitch group-hover:text-champagne-dark transition-colors">{b.name}</h2>
            <p className="text-sm text-charcoal/70 mt-3 leading-relaxed min-h-[3rem]">{b.description}</p>
            <div className="mt-5 text-xs font-mono uppercase tracking-[0.15em] text-stonemuted">{b.product_count} {b.product_count === 1 ? "piece" : "pieces"} available</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
